import { DOCS_FORM_NAMES } from "core/consts";
import { FormFieldConfigFactory } from "../..";
import { createInternalMedicineDischargeLetterPdf } from "./pdfCreator";
import { DischargeLetterInternalMedicineFormSchema } from "./schema";
import { DischargeLetterInternalMedicineFormSections } from "./sections";

export const getDischargeLetterInternalMedicineFormConfig: FormFieldConfigFactory<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_INTERNAL_MEDICINE
> = () => {
  return {
    config: { canPrint: false, canSendToHis: true },
    getInitialValue: ({ value }) => {
      return {
        additional_diagnostic_findings:
          value?.additional_diagnostic_findings ?? "",
        anamnesis: value?.anamnesis ?? "",
        clinical_course: value?.clinical_course ?? "",
        diagnoses: value?.diagnoses ?? "",
        discharge_medications: value?.discharge_medications ?? "",
        physical_status: value?.physical_status ?? "",
        social_anamnesis: value?.social_anamnesis ?? "",
      };
    },
    header: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formInternalMedicine.title,
    pdfConfig: {
      downloadPdfFileName: (translations) =>
        translations.extractDocs.dischargeLetter.generatedPdf
          .savedFileNameInternalMedicine,
      pdfCreator: createInternalMedicineDischargeLetterPdf,
    },
    schema: DischargeLetterInternalMedicineFormSchema,
    sections: DischargeLetterInternalMedicineFormSections,
  };
};
